import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Schema} from '../class/schema';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {UserDataService} from '../role-service/data.service';
import {UserJsPlumbService} from '../role-service/jsPlumb.service';

@Component({
    selector: 'app-user-schema',
    templateUrl: './user-schema.component.html',
    styleUrls: ['./user-schema.component.scss']
})
export class UserSchemaComponent {

    @Input() mySchema: Schema;
    @Input() first;
    @Input() userExcludedPermissions: any;
    @Input() parentRole: any;
    @Input() last;
    @Input() is_pivot;
    @Input() belongsTo;
    @Output() onDeletingSchema: EventEmitter<any> = new EventEmitter<any>();

    private bsModalRef: BsModalRef;

    constructor(private bsModalService: BsModalService, private dataService: UserDataService, private jsPlumbService: UserJsPlumbService) {
    }

    ngAfterViewInit() {
        this.jsPlumbService.initSchema(this.mySchema);
        if (this.userExcludedPermissions && this.userExcludedPermissions.includes(this.mySchema.name)) {
            if (this.belongsTo === 'Permission Groups') {
                document.getElementById(this.mySchema.getElementId()).style.textDecoration = 'line-through';
            }

        }
    }

    ngOnDestroy() {
        this.jsPlumbService.destroySchema(this.mySchema);
    }

    // private editSchema():void{
    //   this.bsModalRef = this.bsModalService.show( ModalSchemaComponent, {initialState:{
    //     mode:'edit',
    //     schema: this.mySchema,
    //     use_laravel_auth: this.dataService.data.use_laravel_auth,
    //     parent_model: this.dataService.data.getModelById(this.mySchema.parent_id)
    //   }} );
    // }
    //
    public deleteSchema() {
        this.onDeletingSchema.emit(this.mySchema);
        //this.dataService.deleteSchema(this.mySchema);
    }


    private moveupSchema() {
        if (!this.first) {
            this.dataService.moveSchema(this.mySchema, -1);
        }
    }

    private movedownSchema() {
        if (!this.last) {
            this.dataService.moveSchema(this.mySchema, 1);
        }
    }

}

